var _path, _path2, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 214,
    viewBox: "0 0 406 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 17L68.9331 29.0669L81 29.5L68.9331 29.9331L68.5 42L68.0669 29.9331L56 29.5L68.0669 29.0669L68.5 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5 0L379.072 15.9283L395 16.5L379.072 17.0717L378.5 33L377.928 17.0717L362 16.5L377.928 15.9283L378.5 0Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.25 32.4067L320.633 41.003L329.593 36.25L320.997 41.6332L325.75 50.5933L320.367 41.997L311.407 46.75L320.003 41.3668L315.25 32.4067Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.127 166.115L394.345 172.852L401.368 169.127L394.631 173.345L398.356 180.368L394.137 173.631L387.115 177.356L393.852 173.137L390.127 166.115Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12652 195.115L11.3454 201.852L18.3675 198.127L11.6305 202.345L15.3555 209.368L11.1367 202.631L4.1145 206.356L10.8515 202.137L7.12652 195.115Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6313 92.2066L19.3436 98.4538L26.056 92.2066L19.8088 98.9189L26.056 105.631L19.3436 99.3841L12.6313 105.631L18.8785 98.9189L12.6313 92.2066Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitter);
export default __webpack_public_path__ + "static/media/glitter.04c5c7eda796bee099d83281d12c4e33.svg";
export { ForwardRef as ReactComponent };